import React, { Component, Fragment } from "react";
import { I18n, Translate as T } from "react-redux-i18n";
import StripeCheckout from "react-stripe-checkout";
import { STRIPE_KEY } from "../../constants";
import LoginButtons from "../Login/LoginButtons";
import Spinner from "../Spinner/Spinner";
import Overlay from "../Overlay/Overlay";

import styles from "./Paywall.css";
import {
  formatCurrencyByLang,
  getCurrencyByLang,
  getSubscriptionAmountByLang
} from "../../helpers/locale";
import Dialog from "../Dialog/Dialog";

export default class Paywall extends Component {
  static defaultProps = {
    lang: "en",
    user: {}
  };

  getCurrency = () => getCurrencyByLang(this.props.lang);
  getSubscriptionAmount = () => getSubscriptionAmountByLang(this.props.lang);

  getFormattedSubscriptionAmount = () =>
    formatCurrencyByLang(this.getSubscriptionAmount() / 100, this.props.lang);

  render = () => (
    <Overlay show={this.props.show}>
      <div className={styles.paywall}>
        {this.props.loading && <Spinner />}
        {!this.props.loading &&
          (this.props.premium ? this.renderPremium() : this.renderNotPremium())}
      </div>
    </Overlay>
  );

  renderPremium = () => (
    <Dialog
      onClose={this.handleCloseClick}
      heading={I18n.t("paywall.premium.heading")}
    >
      <div className={styles.wrapper}>
        <p>
          <T value="paywall.premium.body" dangerousHTML />
        </p>
      </div>
    </Dialog>
  );

  renderNotPremium = () => (
    <Dialog
      onClose={this.handleCloseClick}
      heading={I18n.t("paywall.noPremium.heading")}
    >
      <div className={styles.wrapper}>
        <p>
          <T
            value="paywall.noPremium.body"
            amount={this.getFormattedSubscriptionAmount()}
          />
        </p>
        {!this.props.authenticated ? this.renderAccount() : this.renderBuy()}
      </div>
    </Dialog>
  );

  renderAccount = () => (
    <Fragment>
      <p>
        <T value="paywall.noPremium.accountBody" dangerousHTML />
      </p>
      <LoginButtons />
    </Fragment>
  );

  renderBuy = () => (
    <Fragment>
      <p>
        <T value="paywall.noPremium.buyBody" username={this.props.user.email} />
      </p>
      <StripeCheckout
        name={I18n.t("title")}
        description={I18n.t("paywall.item")}
        email={this.props.user.email}
        stripeKey={STRIPE_KEY}
        token={this.handleStripeToken}
        amount={this.getSubscriptionAmount()}
        currency={this.getCurrency()}
        locale={this.props.lang}
      >
        <button className={styles.button}>
          <T
            value="paywall.noPremium.buyButton"
            amount={this.getFormattedSubscriptionAmount()}
            dangerousHTML
          />
        </button>
      </StripeCheckout>
    </Fragment>
  );

  handleStripeToken = token => this.props.getPaymentStatus(token);

  handleCloseClick = () => this.props.hidePaywall();
}



// WEBPACK FOOTER //
// ./src/components/Paywall/Paywall.js